export const Scoring = {
	ScoresDoesNotScore: 'DoesNotScore',
	ScoresScores:       'Scores'
}


// WEBPACK FOOTER //
// ./src/constants/scoring.js